import { render } from "./App.vue?vue&type=template&id=b43b81e0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b43b81e0&lang=scss"
script.render = render

export default script